import React from 'react';
import { Organization } from '../../../domain/entities/Organization';
import './Header.css';

interface HeaderProps {
  organization: Organization;
}

export const Header: React.FC<HeaderProps> = ({ organization }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src="/casadopandeiro.svg" alt="Casa do Pandeiro" className="logo-icon" />
        </div>
      </div>
    </header>
  );
}; 